import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fcd4056"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "df slide-mode"
}
const _hoisted_2 = { class: "article" }
const _hoisted_3 = { class: "slide jcc" }
const _hoisted_4 = ["onClick", "onMousemove"]
const _hoisted_5 = {
  class: "section",
  "data-anchor": "slider-footer"
}

import { computed, nextTick, onMounted, watch } from 'vue'
import ReportHeader from '@/layouts/PageLayout.vue'
import { Statistics } from '@/widgets/Statistics'
import { ReportsSideBarSlides } from '@/widgets/Sidebar'
import ReportSlider from '@/components/full-page/ReportSlider.vue'
import { DataRelevance } from '@/entities/DataRelevance'
import { MainFooter } from '@/widgets/MainFooter'
import { VectorMap } from '@/entities/VectorMap'
import { useRoute } from 'vue-router'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'
import { ReportTarget } from '../../model/types/report'
import ActivitySegment from '../ActivitySegment/ActivitySegment.vue'
import { useReport } from '../../model/hooks/useReport'
import { useReportMap } from '../../model/hooks/useReportMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportLayoutSlide',
  props: {
    target: null,
    ending: null
  },
  emits: [
	'to'
],
  async setup(__props: any, { emit }) {

let __temp: any, __restore: any

const props = __props as {
	target: ReportTarget,
	ending?: string
};





const goTo = (id: number) => {
	emit('to', id)
}

const route = useRoute()
const store = useAppStore()
const targetType = computed(() => props.target.type)

const {
	anchorList,
	year,
	reportStore,
	sidebarList,
	activitySegmentList,
	targetId
} = (
  ([__temp,__restore] = _withAsyncContext(() => useReport(targetType))),
  __temp = await __temp,
  __restore(),
  __temp
)

const {
	mapItemIsExpanded,
	hoverOnFeature,
	hoveredId,
	locationsList
} = useReportMap(targetType, targetId.value)

watch(() => route.hash, () => {
	nextTick(() => {
		if (location.hash !== '#slider-footer') {
			store.dispatch('checkSection', location.hash)
		}
	})
}, { immediate: true })

const hideLastVerticalNavItem = () => {
	const nav = document.getElementById('fp-nav')
	if (nav) {
		nav.classList.add('nav-without-last')
	} else {
		setTimeout(hideLastVerticalNavItem, 300)
	}
}

onMounted(() => {
	hideLastVerticalNavItem()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (__props.target.type)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ReportsSideBarSlides), { list: _unref(sidebarList) }, null, 8, ["list"]),
        _createElementVNode("article", _hoisted_2, [
          _createVNode(ReportSlider, { anchors: _unref(anchorList) }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "section",
                style: _normalizeStyle(_unref(store).state.isLoading ? 'opacity: 0' : '')
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(ReportHeader, {
                    title: props.target.name,
                    "has-year-select": "",
                    population: props.target.population || 0,
                    "population-density": props.target.density || 0
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_unref(VectorMap), {
                        style: {"flex-shrink":"0"},
                        type: props.target?.type,
                        "location-id": _unref(targetId),
                        "hovered-id": _unref(hoveredId),
                        onHoveredOnFeature: _unref(hoverOnFeature),
                        onClickedOnFeature: goTo
                      }, null, 8, ["type", "location-id", "hovered-id", "onHoveredOnFeature"]),
                      _createVNode(_unref(Statistics), {
                        "is-vertical": props.target?.type === 'country' || _unref(store).state.windowWidth < 1320
                      }, null, 8, ["is-vertical"])
                    ]),
                    _: 2
                  }, [
                    (props.target?.type !== 'region')
                      ? {
                          name: "footer",
                          fn: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["map-items", {'map-items__expend': _unref(mapItemIsExpanded)}])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locationsList), (item) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  onClick: ($event: any) => (goTo(item.id)),
                                  class: _normalizeClass(["map-items__item", { focused: item.id === _unref(hoveredId) }]),
                                  key: item.id,
                                  onMousemove: ($event: any) => (hoveredId.value = item.id),
                                  onMouseout: _cache[0] || (_cache[0] = ($event: any) => (hoveredId.value = undefined))
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(String(item.id).length === 1 ? `0${item.id}` : item.id), 1),
                                  _createTextVNode(" " + _toDisplayString(item.name.toUpperCase()), 1)
                                ], 42, _hoisted_4))
                              }), 128))
                            ], 2)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["title", "population", "population-density"]),
                  _createVNode(_unref(DataRelevance), {
                    "date-in-ms": _unref(reportStore).getTsUpdated,
                    style: {"position":"absolute","left":"calc(5rem + var(--sidebar-width))","bottom":"5rem"}
                  }, null, 8, ["date-in-ms"])
                ])
              ], 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activitySegmentList), (activity) => {
                return (_openBlock(), _createBlock(ActivitySegment, {
                  key: activity.id,
                  year: _unref(year),
                  "report-target": props.target,
                  "activity-segment": activity
                }, null, 8, ["year", "report-target", "activity-segment"]))
              }), 128)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(MainFooter))
              ])
            ]),
            _: 1
          }, 8, ["anchors"])
        ])
      ])), [
        [_directive_loading, _unref(reportStore).getIsLoading]
      ])
    : _createCommentVNode("", true)
}
}

})